const LIMIT_HOTELS_VIEW = 10;

export { LIMIT_HOTELS_VIEW };